import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { AuthService } from './services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly tokenUrl = environment.authUrl; // Authentication URL
  private readonly excludedUrls = ['https://api.ipify.org?format=json', this.tokenUrl];

  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip adding Authorization header for token requests
    if (this.excludedUrls.some((url) => req.url.includes(url))) {
      console.log(`Skipping Authorization for: ${req.url}`);
      return next.handle(req);
    }
    return from(this.authService.ensureTokenIsValid()).pipe(
      switchMap(() => {
        let token = this.authService.getToken();
        if (token) {
          req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        }

        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            console.warn(`Error detected: ${error.status} - ${error.message}`);
            if ([0, 401, 403, 500].includes(error.status)) {
              console.warn('Unauthorized detected - Fetching new token...');
              this.authService.logout();
              return this.handleTokenRetry(req, next);
            }
            return throwError(() => error);
          })
        );
      })
    );
  }

  private handleTokenRetry(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.authService.fetchToken()).pipe(
      switchMap((token) => {
        if (token) {
          console.log('Retrying request with new token:', token);
          req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
          return next.handle(req);
        } else {
          console.error('Unauthorized - Token refresh failed. Logging out...');
          this.authService.authFailed.next(true);
          return throwError(
            () => new Error('Unauthorized - Token expired or invalid')
          );
        }
      })
    );
  }
}
